import React, { useEffect } from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import { BoardHeaderButton } from 'app/src/components/BoardHeaderButton';
import { usePopover, Popover } from '@trello/nachos';
import {
  AutoEnableCalendar,
  PrimaryButtonText,
  PreloadHero,
} from 'app/src/components/AutoEnableCalendar';
import { IconName } from 'app/common/components/controls';

import { sendPluginScreenEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
const CALENDAR_POWER_UP_ID = require('app/scripts/data/legacy-power-ups')
  .calendar;
const format = forTemplate('board_header');

interface CalendarBoardButtonProps {
  idBoard: string;
  backgroundBrightness?: 'dark' | 'light';
  showAutoEnablePopover?: boolean;
  dateAutoEnabled?: number;
  onClick: () => void;
  onDisableCalendarClick: () => void;
  onOpenDirectoryClick: () => void;
  onAutoEnablePopoverShown: () => void;
  countDueDates: () => number;
}

export const CalendarBoardButton: React.FunctionComponent<CalendarBoardButtonProps> = ({
  idBoard,
  backgroundBrightness,
  showAutoEnablePopover,
  dateAutoEnabled,
  onClick,
  onDisableCalendarClick,
  onOpenDirectoryClick,
  onAutoEnablePopoverShown,
  countDueDates,
}) => {
  const { toggle, hide, triggerRef, popoverProps } = usePopover<
    HTMLButtonElement
  >();

  useEffect(() => {
    PreloadHero();
  }, []);

  useEffect(() => {
    if (showAutoEnablePopover && !popoverProps.isVisible) {
      toggle();
      onAutoEnablePopoverShown();
      sendPluginScreenEvent({
        idPlugin: CALENDAR_POWER_UP_ID,
        idBoard,
        screenName: 'autoEnableCalendarInlineDialog',
        attributes: {
          daysFromAutoEnableToFirstToggle: dateAutoEnabled
            ? Math.round((Date.now() - dateAutoEnabled) / (1000 * 60 * 60 * 24))
            : null,
          showAutoEnablePopover,
        },
      });
    }
  }, [
    idBoard,
    showAutoEnablePopover,
    popoverProps,
    onAutoEnablePopoverShown,
    toggle,
    dateAutoEnabled,
  ]);

  return (
    <div>
      <BoardHeaderButton
        backgroundBrightness={backgroundBrightness}
        icon={IconName.Calendar}
        ref={triggerRef}
        onClick={() => {
          onClick();
        }}
        text={format('calendar')}
      />
      <Popover {...popoverProps} title={format('calendar')}>
        <AutoEnableCalendar
          onDisableCalendarClick={() => {
            onDisableCalendarClick();
            hide();
          }}
          primaryButtonCallback={hide}
          primaryButtonText={PrimaryButtonText.OKTHANKS}
          onOpenDirectoryClick={() => {
            onOpenDirectoryClick();
            hide();
          }}
          countDueDates={countDueDates}
          idBoard={idBoard}
        />
      </Popover>
    </div>
  );
};
